import {
  BotStartPayloadDto,
  ChancesEarnedPayloadDto,
  ChancesSpentPayloadDto,
  CheckInStreakMilestonePayloadDto,
  CheckInSucceededPayloadDto,
  DonationConfirmedPayloadDto,
  DonationLargeReceivedPayloadDto,
  DonationReceivedPayloadDto,
  DreamApprovedPayloadDto,
  DreamClosedPayloadDto,
  DreamDeletedPayloadDto,
  DreamFrozenPayloadDto,
  DreamGoalReachedPayloadDto,
  DreamRejectedPayloadDto,
  DreamUnfrozenPayloadDto,
  FarmingPointsClaimedPayloadDto,
  FarmingSessionCompletedPayloadDto,
  FarmingSessionStartedPayloadDto,
  PointsEarnedLargePayloadDto,
  PointsEarnedPayloadDto,
  PointsSpentPayloadDto,
  ReferralBonusClaimedPayloadDto,
  ReferralBonusEarnedPayloadDto,
  ReferralBonusExpiredPayloadDto,
  ReferralMilestonePayloadDto,
  ReferralNewUserPayloadDto,
  RouletteBigWinPayloadDto,
  SseEventDtoData,
  SseEventDtoDataEvent,
  SseEventDtoDataPayload,
  SseEventDtoEvent,
  SseEventDtoDataScope,
  SystemAnnouncementPayloadDto,
  SystemMaintenancePayloadDto,
  TransactionConfirmedPayloadDto,
  TransactionFailedPayloadDto,
  TransactionStatusChangedPayloadDto,
  UserInactiveReminderPayloadDto,
  WalletLinkedPayloadDto,
  WalletUnlinkedPayloadDto,
  WithdrawalCompletedPayloadDto,
  WithdrawalFailedPayloadDto,
  WithdrawalRequestedPayloadDto,
  WithdrawalApprovedPayloadDto,
  WithdrawalRejectedPayloadDto,
} from '@/api/model'
import { accessToken } from '@/shared/auth'
import { isString } from '@/shared/lib/isString'
import { toast } from '@/shared/toaster'

type Listener<T> = (even: MessageEvent<T>) => void

type SseEventDtoDataModified<
  E extends SseEventDtoDataEvent,
  P extends SseEventDtoDataPayload,
> = SseEventDtoData & { event?: E; payload?: P }

export type Listeners = {
  [SseEventDtoEvent.systemmaintenance]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.systemmaintenance,
      SystemMaintenancePayloadDto
    >
  >[]
  [SseEventDtoEvent.systemannouncement]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.systemannouncement,
      SystemAnnouncementPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamfrozen]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamfrozen,
      DreamFrozenPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamunfrozen]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamunfrozen,
      DreamUnfrozenPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamapproved]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamapproved,
      DreamApprovedPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamrejected]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamrejected,
      DreamRejectedPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamclosed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamclosed,
      DreamClosedPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamgoal_reached]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamgoal_reached,
      DreamGoalReachedPayloadDto
    >
  >[]
  [SseEventDtoEvent.dreamdeleted]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.dreamdeleted,
      DreamDeletedPayloadDto
    >
  >[]
  [SseEventDtoEvent.donationreceived]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.donationreceived,
      DonationReceivedPayloadDto
    >
  >[]
  [SseEventDtoEvent.donationconfirmed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.donationconfirmed,
      DonationConfirmedPayloadDto
    >
  >[]
  [SseEventDtoEvent.donationlarge_received]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.donationlarge_received,
      DonationLargeReceivedPayloadDto
    >
  >[]
  [SseEventDtoEvent.farmingsession_started]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.farmingsession_started,
      FarmingSessionStartedPayloadDto
    >
  >[]
  [SseEventDtoEvent.farmingsession_completed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.farmingsession_completed,
      FarmingSessionCompletedPayloadDto
    >
  >[]
  [SseEventDtoEvent.farmingpoints_claimed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.farmingpoints_claimed,
      FarmingPointsClaimedPayloadDto
    >
  >[]
  [SseEventDtoEvent.referralbonus_earned]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.referralbonus_earned,
      ReferralBonusEarnedPayloadDto
    >
  >[]
  [SseEventDtoEvent.referralbonus_claimed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.referralbonus_claimed,
      ReferralBonusClaimedPayloadDto
    >
  >[]
  [SseEventDtoEvent.referralnew_user]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.referralnew_user,
      ReferralNewUserPayloadDto
    >
  >[]
  [SseEventDtoEvent.referralbonus_expired]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.referralbonus_expired,
      ReferralBonusExpiredPayloadDto
    >
  >[]
  [SseEventDtoEvent.referralmilestone]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.referralmilestone,
      ReferralMilestonePayloadDto
    >
  >[]
  [SseEventDtoEvent.transactionconfirmed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.transactionconfirmed,
      TransactionConfirmedPayloadDto
    >
  >[]
  [SseEventDtoEvent.transactionfailed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.transactionfailed,
      TransactionFailedPayloadDto
    >
  >[]
  [SseEventDtoEvent.transactionstatus_changed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.transactionstatus_changed,
      TransactionStatusChangedPayloadDto
    >
  >[]
  [SseEventDtoEvent.walletlinked]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.walletlinked,
      WalletLinkedPayloadDto
    >
  >[]
  [SseEventDtoEvent.walletunlinked]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.walletunlinked,
      WalletUnlinkedPayloadDto
    >
  >[]
  [SseEventDtoEvent.withdrawalrequested]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.withdrawalrequested,
      WithdrawalRequestedPayloadDto
    >
  >[]
  [SseEventDtoEvent.withdrawalapproved]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.withdrawalapproved,
      WithdrawalApprovedPayloadDto
    >
  >[]
  [SseEventDtoEvent.withdrawalrejected]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.withdrawalrejected,
      WithdrawalRejectedPayloadDto
    >
  >[]
  [SseEventDtoEvent.withdrawalcompleted]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.withdrawalcompleted,
      WithdrawalCompletedPayloadDto
    >
  >[]
  [SseEventDtoEvent.withdrawalfailed]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.withdrawalfailed,
      WithdrawalFailedPayloadDto
    >
  >[]
  [SseEventDtoEvent.checkinsucceeded]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.checkinsucceeded,
      CheckInSucceededPayloadDto
    >
  >[]
  [SseEventDtoEvent.checkinstreak_milestone]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.checkinstreak_milestone,
      CheckInStreakMilestonePayloadDto
    >
  >[]
  [SseEventDtoEvent.checkinrestore_available]: Listener<unknown>[]
  [SseEventDtoEvent.roulettebig_win]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.roulettebig_win,
      RouletteBigWinPayloadDto
    >
  >[]
  [SseEventDtoEvent.pointsearned]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.pointsearned,
      PointsEarnedPayloadDto
    >
  >[]
  [SseEventDtoEvent.pointsearned_large]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.pointsearned_large,
      PointsEarnedLargePayloadDto
    >
  >[]
  [SseEventDtoEvent.pointsspent]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.pointsspent,
      PointsSpentPayloadDto
    >
  >[]
  [SseEventDtoEvent.chancesearned]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.chancesearned,
      ChancesEarnedPayloadDto
    >
  >[]
  [SseEventDtoEvent.chancesspent]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.chancesspent,
      ChancesSpentPayloadDto
    >
  >[]
  [SseEventDtoEvent.userinactive_reminder]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.userinactive_reminder,
      UserInactiveReminderPayloadDto
    >
  >[]
  [SseEventDtoEvent.botstart]: Listener<
    SseEventDtoDataModified<
      typeof SseEventDtoEvent.botstart,
      BotStartPayloadDto
    >
  >[]
  [SseEventDtoEvent.userearly_access_granted]: Listener<unknown>[]
}

const baseUrl =
  import.meta.env.VITE_USE_PROXY === 'true'
    ? '/api'
    : import.meta.env.VITE_API_URL || ''

export const startSSE = () => {
  const listeners: Partial<Listeners> = {}
  const MAX_RECONNECT_DELAY = 30000
  let lastPingTime = Date.now()
  let healthCheckIntervalId: NodeJS.Timeout | undefined = undefined
  let reconnectDelay = 1000
  let reconnectTimeOut: NodeJS.Timeout | undefined = undefined

  const ping = (e: MessageEvent) => {
    lastPingTime = Date.now()

    import.meta.env.VITE_SSE_TOAST_ON_PING === '1' &&
      toast.success(`Ping received: ${e.data}`)
  }

  const onOpen = () => {
    reconnectDelay = 1000
    lastPingTime = Date.now()
    healthCheckIntervalId = setInterval(() => {
      const timeSinceLastPing = Date.now() - lastPingTime

      if (timeSinceLastPing > 30000) {
        // eslint-disable-next-line no-console
        console.warn('Connection seems dead, reconnecting...')

        reconnect()
      }
    }, 5000)
  }

  const initEs = () => {
    const es = new EventSource(`${baseUrl}/events?token=${accessToken.value}`, {
      withCredentials: import.meta.env.VITE_SSE_WITH_CREDENTIALS === '1',
    })

    es.addEventListener('error', onError)
    es.addEventListener('ping', ping)
    es.addEventListener('open', onOpen)

    Object.entries(listeners).forEach(([event, cbs]) =>
      cbs.forEach((cb) => es.addEventListener(event, listenersMap.get(cb))),
    )

    return es
  }
  const listenersMap = new Map()

  let es = initEs()

  const addListener = <T extends keyof Listeners>(
    event: T,
    cb: Listeners[T][number],
    scope?: SseEventDtoDataScope,
  ) => {
    !listeners[event] && (listeners[event] = [])

    listeners[event].push(cb)

    const parseData = (event: MessageEvent) => {
      const data = isString(event.data) ? JSON.parse(event.data) : event.data

      Object.defineProperty(event, 'data', { value: data })
      ;(!scope || data.scope === scope) && cb(event)
    }

    listenersMap.set(cb, parseData)

    es.addEventListener(event, parseData)
  }

  const removeListener = <T extends keyof Listeners>(
    event: T,
    cb: Listeners[T][number],
  ) => {
    if (!listenersMap.has(cb)) return

    listeners[event] = listeners[event]
      ? (listeners[event].filter(
          (fn) => fn !== listenersMap.get(cb),
        ) as Listeners[T])
      : []

    es.removeEventListener(event, listenersMap.get(cb))

    listenersMap.delete(cb)
  }

  const _close = () => {
    Object.entries(listeners).forEach(([event, cbs]) =>
      cbs.forEach((cb) => {
        es.removeEventListener(event, listenersMap.get(cb))
      }),
    )
    es.removeEventListener('error', onError)
    es.removeEventListener('ping', ping)
    es.removeEventListener('open', onOpen)

    healthCheckIntervalId && clearInterval(healthCheckIntervalId)
    reconnectTimeOut && clearTimeout(reconnectTimeOut)

    healthCheckIntervalId = undefined
    reconnectTimeOut = undefined

    es.close()
  }

  function reconnect() {
    _close()
    es = initEs()
  }

  function onError(...r) {
    // eslint-disable-next-line no-console
    console.log({ r }, 'error')

    _close()

    reconnectTimeOut = setTimeout(() => {
      reconnectDelay = Math.min(reconnectDelay * 2, MAX_RECONNECT_DELAY)
      es = initEs()
    }, reconnectDelay)
  }

  const close = () => {
    _close()

    listenersMap.clear()
  }

  return { addListener, removeListener, reconnect, close }
}
